import { render, staticRenderFns } from "./DetailDeleteModal.vue?vue&type=template&id=3db87a7c&scoped=true&"
import script from "./DetailDeleteModal.vue?vue&type=script&lang=js&"
export * from "./DetailDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db87a7c",
  null
  
)

export default component.exports